/**
 * Client Acceptance(CAF) 반복 행 id — 다른 문서 화면이 CAF 인물 행을 **같은 키로 편집**할 때 쓴다.
 *
 * CAF 가 `caf_ids_dir = "1,2,4"` 처럼 실제로 떠 있는 행을 알려 주면 그걸 쓴다. 이름 칸을 지우는
 * 도중에도 행이 사라지지 않게 하려는 것(이름 기준으로만 거르면 한 글자 남기고 지우는 순간 행이
 * 없어져 입력 포커스가 날아간다). 알림이 없으면 이름이 있는 행만.
 */
export function cafRowIds(
  values: Record<string, unknown>,
  prefix: string,
  nameSuffix: string,
  max = 50,
): number[] {
  const raw = String(values[`caf_ids_${prefix}`] ?? '').trim();
  if (raw) {
    const ids = raw.split(',').map((s) => Number(s.trim())).filter((n) => Number.isFinite(n) && n > 0);
    if (ids.length) return ids;
  }
  const out: number[] = [];
  for (let i = 1; i <= max; i++) {
    if (String(values[`${prefix}${i}_${nameSuffix}`] ?? '').trim()) out.push(i);
  }
  return out;
}
